import { composeFieldPath } from '@northfork/basics'

export interface CorporateActionDetailsModel {
  property: string
  value: string
}
export const corporateActionDetailsModelField = composeFieldPath(
  [] as CorporateActionDetailsModel[],
)

export enum CorporateActionDetailPropertyField {
  ID = 'Id',
  TYPE = 'Type',
  ACTION = 'Action',
  EFFECTIVEDATE = 'effectiveDate',
  JIRA = 'Jira',
  STATUS = 'Status',
  CREATED = 'Created',
  LASTUPDATED = 'Last Updated',
  CREATEDBY = 'Created By',
  NOTES = 'Notes',
  NEEDSWORK = 'needsWork',
}

export enum CorporateActionDetailValueField {
  ID = 'id',
  TYPE = 'type',
  MANDATORY = 'mandatory',
  EFFECTIVEDATE = 'effectiveDate',
  JIRAISSUEKEY = 'jiraIssueKey',
  STATUS = 'status',
  CREATEDDATETIME = 'createdDateTime',
  UPDATEDDATETIME = 'updatedDateTime',
  CREATEDBYUSERID = 'createdByUserId',
  NOTES = 'notes',
  NEEDSWORK = 'needsWork',
}

export const corporateActionDetailFieldMap = new Map<string, string>([
  [CorporateActionDetailValueField.ID, CorporateActionDetailPropertyField.ID],
  [
    CorporateActionDetailValueField.TYPE,
    CorporateActionDetailPropertyField.TYPE,
  ],
  [
    CorporateActionDetailValueField.MANDATORY,
    CorporateActionDetailPropertyField.ACTION,
  ],
  [
    CorporateActionDetailValueField.EFFECTIVEDATE,
    CorporateActionDetailPropertyField.EFFECTIVEDATE,
  ],
  [
    CorporateActionDetailValueField.JIRAISSUEKEY,
    CorporateActionDetailPropertyField.JIRA,
  ],
  [
    CorporateActionDetailValueField.STATUS,
    CorporateActionDetailPropertyField.STATUS,
  ],
  [
    CorporateActionDetailValueField.CREATEDDATETIME,
    CorporateActionDetailPropertyField.CREATED,
  ],
  [
    CorporateActionDetailValueField.UPDATEDDATETIME,
    CorporateActionDetailPropertyField.LASTUPDATED,
  ],
  [
    CorporateActionDetailValueField.CREATEDBYUSERID,
    CorporateActionDetailPropertyField.CREATEDBY,
  ],
  [
    CorporateActionDetailValueField.NOTES,
    CorporateActionDetailPropertyField.NOTES,
  ],
  [
    CorporateActionDetailValueField.NEEDSWORK,
    CorporateActionDetailPropertyField.NEEDSWORK,
  ],
])

export interface SecurityGroup {
  Parents: string[]
  Children: string[]
}
